import React from 'react';
import { Quantity as BaseQuantity, QuantityProps } from '@teko/ds-desktop';
import { numberFormatter, numberParser } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'hooks';
import { DEFAULT_NUMBER_DISPLAY_FORMAT } from 'constants/index';
import { getEnv } from 'helpers';

export const Quantity: React.FC<QuantityProps> = (props) => {
  const { numberDisplayFormat } = useTenantConfig();

  return (
    <BaseQuantity
      {...(getEnv('EPIC_ECOM_489') === 'enabled'
        ? {
            decimalSeparator:
              numberDisplayFormat?.decimalSeparator ||
              DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator,
            formatter: (value) =>
              numberFormatter(
                value,
                numberDisplayFormat || DEFAULT_NUMBER_DISPLAY_FORMAT,
              ),
            parser: (value) =>
              numberParser(
                value,
                numberDisplayFormat || DEFAULT_NUMBER_DISPLAY_FORMAT,
              ),
          }
        : {})}
      {...props}
    />
  );
};
